<!--
    课程商品-课时编辑-校区学科分类-分类树
    作用：校区学科分类下的分类数据
    组件:旧版本
-->
<template>
  <div>
    <el-tree
      ref="tree"
      :data="data"
      :default-expanded-keys="[]"
      :default-checked-keys="defaultValue"
      :props="defaultProps"
      show-checkbox
      node-key="id"
      @check="onCheck"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'TreeBox',
  props: {
    subjectId: {
      type: [Number, String],
      default: '',
    },
    defaultValue: Array,
  },
  data() {
    return {
      newSubjectId: this.subjectId,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    };
  },
  computed: {
    getCheckeds() {
      return this.$refs.tree.getCheckedKeys();
    },
    getCheckedsNode() {
      return this.$refs.tree.getCheckedNodes();
    },
    getHalfCheckedNodes() {
      return this.$refs.tree.getHalfCheckedNodes();
    },
    getHalfCheckedKeys() {
      return this.$refs.tree.getHalfCheckedKeys();
    },
    // 获取所有选中的最后一个叶子节点集合
    getCurSelectedLeaf() {
      const arr = this.getCheckedsNode;
      const list = [];
      arr.forEach((v) => { if (v.leaf) { list.push(v.id); } });
      return list;
    },
  },
  watch: {
    subjectId(vl) { this.newSubjectId = vl; },
    newSubjectId: {
      handler(vl) {
        this.$emit('update:subjectId', vl);
        this.structureTree();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // 获取结构树
      // this.structureTree();
    },
    async structureTree() {
      if (this.newSubjectId) {
        const res = await this.$http.get(`/api/imkid/structure_tree/${this.newSubjectId}`);
        console.log('获取结构树==>', res);
        this.data = res.structureTree;
        this.$emit('success');
      }
    },
    getTreeData(){
      return this.data
    },
    currentChange(data, node) {
      console.log('setChecked==>', data, node);
      this.$emit('onTreeBox', data, node);
    },
    onCheck(data, node) {
      this.$emit('onCheck', data, node);
      this.$emit('onSelected', this.getCurSelectedLeaf);
    },
    setCheckedKeys(data){
      this.$refs.tree && this.$refs.tree.setCheckedKeys(data)
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Goods/editClass/components/catalog/components/treeBox/index.vue